import React, { FC, useEffect, useState } from 'react'

import { Box, SxProps, Tooltip, Typography, useTheme } from '@mui/material'
import { EthAddr } from '@shared/SchemaTypes'

interface AddressPillProps {
  addr: string | EthAddr
  href?: string
  style?: SxProps
  labelStyle?: SxProps
}

export const AddressPill: FC<AddressPillProps> = ({ addr, href, style = {}, labelStyle = {} }) => {
  const theme = useTheme()
  const addrCompressed = `${addr?.slice(0, 8)}...`

  const [clicked, setClicked] = useState(false)
  const [currentTooltip, setCurrentTooltip] = useState(addr)

  useEffect(() => {
    if (clicked) {
      setCurrentTooltip('Copied to clipboard')
    } else {
      setCurrentTooltip(addr)
    }

    setTimeout(() => {
      setClicked(false)
    }, 2500)
  }, [clicked])

  const handleClick = (): void => {
    if (href) {
      window.open(href)
    }
    setClicked(true)
    navigator.clipboard.writeText(addr).catch((_e) => {})
  }

  const componentStyle = href ? {} : { borderRadius: 8, backgroundColor: theme.palette.info.subtle }

  const textStyle = {
    textDecoration: href ? 'underline' : 'none',
    color: href ? theme.palette.accent1.dark : '#000',
    ...labelStyle,
    fontSize: '12px',
    lineHeight: '1',
  }

  return (
    <Box
      onClick={handleClick}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: 1,
        marginBottom: 3,
        paddingRight: 2,
        paddingLeft: 2,
        paddingTop: 1,
        paddingBottom: 1,
        alignSelf: 'flex-start',
        cursor: 'pointer',
        marginRight: 2,
        ...componentStyle,
        ...style,
        alignContent: 'center',
      }}
    >
      <Tooltip title={currentTooltip}>
        <Typography variant="bodyBold" sx={textStyle}>
          {addrCompressed}
        </Typography>
      </Tooltip>
    </Box>
  )
}
